import type { ReactNode } from "react";

import { Divider } from "@/components/Divider/Divider";

type Props = {
  title: ReactNode;
  summary?: ReactNode;
  footer?: ReactNode;
  children: ReactNode;
};

export const PaymentDetails = ({ title, summary, footer, children }: Props) => {
  return (
    <div className="section-card flex flex-col gap-4">
      {title ? (
        <div className="text-lg font-medium text-text-primary">{title}</div>
      ) : null}

      <dl className="grid grid-cols-2 gap-3 text-sm">{children}</dl>

      {summary != null ? (
        <>
          <Divider color="neutral-soft" />
          {summary}
        </>
      ) : null}

      {footer ? <div>{footer}</div> : null}
    </div>
  );
};
